import React, { useEffect, useState } from "react";
import { Seo, Section, SectionHead, FadeUp } from "./Ui";
import { NEWS_FALLBACK } from "./data";
import axios from "axios";

export default function DrezoroNews() {
  const [items, setItems] = useState(NEWS_FALLBACK);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/drezoro/news`)
      .then((r) => { if (Array.isArray(r.data) && r.data.length) setItems(r.data); })
      .catch(() => {});
  }, []);
  return (
    <div data-testid="drezoro-news">
      <Seo title="News & Press — DREZORO" description="Official announcements, product launches, and press from DREZORO and its family of companies." />
      <Section>
        <SectionHead label="News & Press" title="Announcements from the DREZORO group."
          intro="Product launches, company milestones, and official statements — published here first." />
        <div className="space-y-5 max-w-4xl">
          {items.map((n, i) => (
            <FadeUp key={n.id} delay={i * 0.05}>
              <article className="dz-card p-7" data-testid={`dz-newsitem-${n.id}`}>
                <div className="flex items-center gap-3 text-xs text-zinc-500 mb-3">
                  <span className="text-blue-400 uppercase tracking-wider font-semibold">{n.tag}</span>
                  <time dateTime={n.date}>{n.date}</time>
                </div>
                <h2 className="text-lg md:text-xl font-medium leading-snug text-white">{n.title}</h2>
                <p className="mt-3 text-sm md:text-base text-zinc-400 leading-relaxed">{n.body}</p>
              </article>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mt-10">
          <p className="text-sm text-zinc-500">Press enquiries: <a href="mailto:info@drezoro.com" className="text-blue-400 hover:text-blue-300" data-testid="dz-press-email">info@drezoro.com</a></p>
        </FadeUp>
      </Section>
    </div>
  );
}
